import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Create, FormManager, FormRow, PageTitle, useCloneEntity } from 'gossamer-front-end';
import { BookingPaymentTerms, BookingPaymentTermsRow } from 'cb-model';
import { useFormikContext } from 'formik';

const ClearCanxAllowedHoursWhenNoRefund = ({ entity }: { entity: typeof BookingPaymentTerms }): React.JSX.Element => {
  const { values, setFieldValue } = useFormikContext<any>();
  const noCanxRefund = Boolean(values?.main?.no_canx_refund);
  const currentAllowedHours = values?.main?.canx_allowed_hours_before_start;

  // Keep the field visible, but read-only when refunds are disabled.
  entity.fields.canx_allowed_hours_before_start.visible = true;
  entity.fields.canx_allowed_hours_before_start.editable = !noCanxRefund;

  useEffect(() => {
    if (!noCanxRefund) return;
    if (currentAllowedHours == null) return;
    void setFieldValue(`main.canx_allowed_hours_before_start`, null);
  }, [noCanxRefund, currentAllowedHours, setFieldValue]);

  return null;
};

export const BookingPaymentTermsUpsert = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();

  const LocalBookingPaymentTerms = useCloneEntity(BookingPaymentTerms);
  LocalBookingPaymentTerms.fields.id.visible = false;
  LocalBookingPaymentTerms.fields.institution_id.visible = false;

  const handleExit = () => navigate(`/admin/event-profile/display/${params.key}`);

  return (
    <>
      <PageTitle verb="Create" entity={LocalBookingPaymentTerms} />
      <FormManager
        compoundUrl={`/main/booking-payment-terms-create/${params.key}`}
        handleCancel={handleExit}
        handlePreSubmit={(values) => {
          const main = values?.main as FormRow<BookingPaymentTermsRow>;
          if (main?.no_canx_refund) {
            main.canx_allowed_hours_before_start = null;
          }
        }}
        handleSuccess={(_resp, resetCache) => {
          resetCache('EventProfile', params.key);
          handleExit();
        }}
        initialization={{
          main: {
            type: 'create-single',
            entity: LocalBookingPaymentTerms,
          },
        }}
      >
        <ClearCanxAllowedHoursWhenNoRefund entity={LocalBookingPaymentTerms} />
        <Create entity={LocalBookingPaymentTerms} valuesKey="main" />
      </FormManager>
    </>
  );
};
